import React from 'react';
import ButtonGeneral from '../../../../components/buttons/ButtonGeneral';
import InputField from '../../../../components/InputField/InputField';
import SelectTwo from '../../../../components/SelectTwo';

type Props = {
    filter: any;
    setFilter: (filter: any) => void;
    onSearch: () => void;
};

const FAQFilter = ({ filter, setFilter, onSearch }: Props) => {
    const statusOptions = [
        { value: '', label: 'Todos los estados' },
        { value: 'true', label: 'Activos' },
        { value: 'false', label: 'Inactivos' }
    ];

    return (
        <div className="row">
            <div className="row">
                <div className="col-md-auto">
                    <InputField
                        type="text"
                        label="Buscar"
                        value={filter.search || ''}
                        onChange={(value) => setFilter({ ...filter, search: value })}
                        placeholder="Buscar por pregunta o respuesta"
                        size="small"
                    />
                </div>
                <div className="col-md-auto">
                    <SelectTwo
                        label="Estado"
                        inputValue={filter.is_active || ''}
                        onChange={(option) => setFilter({ ...filter, is_active: option?.value || '' })}
                        options={statusOptions}
                        isClearable={false}
                    />
                </div>

                <div className='col-md-auto'>
                    <div>
                        <ButtonGeneral
                            onClick={onSearch}
                            title="Buscar"
                            variant="outline"
                            size="small"
                            icon="fa-search"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQFilter;

